module.exports = __webpack_public_path__ + "img/pro8.911e5b72.png";